import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFlaskComponent } from './simple-icons-flask.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFlaskComponent ],
    exports:      [ SimpleIconsFlaskComponent ],
    bootstrap:    []
})
export class SimpleIconsFlaskModule {}
